<template lang="pug">
#send-safety-confirm-to-other-user-complete
  // title
  .d-flex.flex-row.justify-content-center.mb-2
    .page-title 施設関係者へ安否確認入力依頼のメッセージ送信

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // message
  .mb-3 メッセージを受付ました。

  // buttons
  .d-flex.flex-row.justify-content-center
    b-button.btn.back-btn(@click="onGotoList") 安否確認一覧へ
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";
import { MobileUrl } from "@/commons/constants/MobileUrl";

/**
 * ### 安否確認 事前設定(施設関係者) 完了コンポーネント
 */
@Component({
  components: {
    ProcessIndicator
  }
})
export default class SendSafetyConfirmToOtherUserComplete extends Vue {
  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: false },
    { text: "確認", current: false },
    { text: "完了", current: true }
  ];

  /**
   * ### 安否確認一覧へボタン押下イベント
   *
   * - 安否確認一覧画面へ遷移する
   */
  public onGotoList(): void {
    this.$router.push(MobileUrl.SafetyConfirmList);
    return;
  }
}
</script>

<style lang="scss" scopeed>
#send-safety-confirm-to-other-user-complete {
  .back-btn {
    min-width: 124px;
  }
}
</style>
